import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseSelectDropdown from './HseSelectDropdown.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseSelectDropdown;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HseDropdownMenu',_vm._b({ref:"root",staticClass:"hse-Select__menu",class:{
    'hse-Select__menu_opened': _vm.isOpen
  },attrs:{"borderless":_vm.isBorderless},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("header")]},proxy:true}],null,true)},'HseDropdownMenu',_vm.$attrs,false),[_vm._v(" "),[(_vm.message)?_c('HseDropdownMenuMessage',{class:_vm.dropdownMenuMessageClasses},[_vm._t("message",[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])],2):_vm._e(),_vm._v(" "),_vm._t("default")]],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
